<template>
  <img class="logo" src="/img/logos/longboss.png" alt="KoalaBoss logo" />
</template>

<script>
export default {
  name: 'LogoLongBoss',
};
</script>
